import bilAPI from "./api";

// `page_size` lets the bell load the whole set so the unread badge (computed
// client-side) and the dropdown aren't capped at the first 20.
export const getNotifications = ({ params: { page, page_size } = {}, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/notifications/`, { params: { page, page_size }, signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const markNotificationRead = ({ uuid, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/notifications/${uuid}/read/`, null, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const markAllNotificationsRead = ({ signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/notifications/read-all/`, null, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};
